import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const StyledLink = styled(Link)`
  display: inline-block;
  background-color: #497E6E;
  color: #fff;
  padding: .75rem;
  border-radius: 45px;
  border: 2px outset buttonface;

  &:hover {
    background-color: #36594E;
    box-shadow: 0px 5px 40px -10px rgba(0,0,0,0.57);
    transition: all 0.4s ease 0s;
    text-decoration: none;
    color: #fff;
  }
  
  &:disabled {
    background-color: #497E6E;
    opacity: 0.6;
    box-shadow: 0px 0px 0px;
    transition: none;
    cursor: default;
  }
`;

export const StyledButton = styled.button`
  background-color: #497E6E;
  color: #fff;
  padding: .75rem;
  border-radius: 45px;
  border: 2px outset buttonface;
  cursor: pointer;

  &:hover {
    background-color: #36594E;
    box-shadow: 0px 5px 40px -10px rgba(0,0,0,0.57);
    transition: all 0.4s ease 0s;
    text-decoration: none;
    color: #fff;
  }
  
  &:disabled {
    background-color: #497E6E;
    opacity: 0.6;
    box-shadow: 0px 0px 0px;
    transition: none;
    cursor: default;
  }
`;